import { useEffect, useState } from 'react'
import ReservationBoxCheckout from './ReservationBoxCheckout'
import { PaymentAPI } from '../../api/PaymentAPI'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Button } from '@mui/material'
import { rootAction } from '../../redux/reducer/rootReducer'
import Loader from '../../component/Loader'
import { CoachSchedulerAPI } from '../../api/CoachSchedulerAPI'
import {
    CHECKOUT_VENDOR_REQUIRED,
    FINANCIAL_VENDOR_PATH,
    checkoutVendorErrorMessage,
} from '../../util/financialVendorGate'

const ScheduleCartDetails = () => {
    document.title = "Reservation Checkout"
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [checkoutDetails, setCheckoutDetails] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loadingCount, setLoadingCount] = useState(0);
    const [isUpdate, setIsUpdate] = useState(false);
    const [vendorRequired, setVendorRequired] = useState(false);

    const startLoading = () => {
        setLoadingCount(prevCount => prevCount + 1);
    };
    const finishLoading = () => {
        setLoadingCount(prevCount => prevCount - 1);
    };

    useEffect(() => {
        if (selectedClub.clubId && userInfo.userId) {
            calculatePricing();
        }
        isUpdate && setIsUpdate(false);
    }, [userInfo.userId, selectedClub.clubId, isUpdate])

    const calculatePricing = async () => {
        try {
            const paymentInfo = {
                userId: userInfo.userId,
                clubId: selectedClub.clubId
            }
            startLoading();
            const response = await PaymentAPI.postCalculateEventSchedulePricing(paymentInfo);
            setCheckoutDetails(response.Data);
        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }

    }
    const handleConfirmFreeReservation = async () => {
        try {
            startLoading();
            const response = await CoachSchedulerAPI.putConfirmFreeSchedule({ userId: userInfo.userId, clubId: selectedClub.clubId });
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Reservation confirmed successfully.' }));
            setIsUpdate(true);
            setTimeout(() => {
                dispatch(rootAction.setIsUpdateTotalSchedule(true));
            }, 1000);
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Something went wrong' }));
        } finally {
            finishLoading();
        }
    }

    const handleCheckout = async () => {

        if (checkoutDetails?.warning) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: checkoutDetails?.warning }));
            return;
        }

        if (checkoutDetails?.totalAmount === '0.00') {
            handleConfirmFreeReservation();
            return;
        }
        try {
            const paymentDetails = {
                userId: userInfo.userId,
                paymentCreatedBy: userInfo.userId,
                clubId: selectedClub.clubId,
                amount: checkoutDetails?.totalAmount,
                paymentType: "onSchedulePayment"
            }
            startLoading();
            const paymentIntentResponse = await PaymentAPI.postCreatePaymentIntent(paymentDetails);
            dispatch(rootAction.setPaymentIntentId(paymentIntentResponse.Data.paymentIntentId));
            finishLoading();
            navigate('/payment', {
                state: {
                    clientSecret: paymentIntentResponse.Data.paymentIntentClientSecret,
                    paymentIntentId: paymentIntentResponse.Data.paymentIntentId,
                    reservationFor: paymentDetails.userId,
                    priceDetails: {
                        totalHour: checkoutDetails?.totalHour,
                        totalReservations: checkoutDetails?.totalReservations,
                        totalAmount: paymentIntentResponse.Data.totalAmount,
                        processingFee: paymentIntentResponse.Data.processingFee,
                    }
                }
            })
        } catch (error) {
            finishLoading();
            const vendorMessage = checkoutVendorErrorMessage(error);
            if (vendorMessage) {
                setVendorRequired(true);
                dispatch(rootAction.setWarningMessage({
                    id: Date.now(),
                    type: 'error',
                    content: vendorMessage,
                }));
            }
        }
    }



    if (loadingCount > 0) {
        return <Loader />
    }

    return (
        <div className='cart_page_container'>
            {checkoutDetails && checkoutDetails.schedules.length != 0
                ?
                <>
                    <div className="reservation_details_for_checkout" >
                        <h1>Schedule Details:</h1>

                        {checkoutDetails?.schedules?.map((item) =>
                            <ReservationBoxCheckout
                                key={item.reservationId}
                                selectedClub={selectedClub}
                                startLoading={startLoading}
                                finishLoading={finishLoading}
                                isReservation={false}
                                schedule={item}
                                setIsUpdate={setIsUpdate}
                            />
                        )}
                    </div>
                    <div className="reservation_price_detals_body">
                        <h1>Price Details</h1>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalReservations) > 1 ? 'Total Reservations' : 'Total Reservation'}</p>
                            <p>{checkoutDetails?.totalReservations}</p>
                        </div>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalHour) > 1 ? 'Total Hours' : 'Total Hour'}</p>
                            <p>{checkoutDetails?.totalHour}</p>
                        </div>
                        {Number(checkoutDetails?.processingFee) > 0 &&
                        <div className="reservation_price_detals_row">
                            <p>Processing Fee</p>
                            <p>${checkoutDetails.processingFee}</p>
                        </div>}
                        <div className="reservation_horizontal_line"></div>
                        <div className="reservation_price_detals_row">
                            <p>Total Amount:</p>
                            <p>${checkoutDetails?.totalAmount}</p>
                        </div>
                        <button onClick={handleCheckout}>checkout</button>
                        {vendorRequired &&
                            <Button
                                data-testid="financial-vendor-link"
                                onClick={() => navigate(FINANCIAL_VENDOR_PATH)}
                            >
                                {CHECKOUT_VENDOR_REQUIRED}
                            </Button>}
                    </div>
                </>
                :
                <div className='checkout_reservation_not_found' data-testid="empty-schedule-cart">
                    <div className="empty-cart-card">
                        <p className="empty-cart-kicker">Cart</p>
                        <h1>Nothing to check out yet</h1>
                        <p className="empty-cart-lead">Add a paid event on Coach Schedule, then come back here to pay.</p>
                        <Button
                            data-testid="empty-schedule-cart-book"
                            onClick={() => {
                                navigate('/coach-scheduler');
                                dispatch(rootAction.setSlideBarLink('calendar'));
                            }}
                            variant='contained'
                        >
                            Open Coach Schedule
                        </Button>
                    </div>
                </div>}
        </div>
    )
}

export default ScheduleCartDetails